import {
	dashboardDeleteBusinessReminder,
	DashboardDeleteBusinessReminderProps,
	dashboardResetBusinessReminder,
	dashboardSetBusinessReminder,
	DashboardSetBusinessReminderProps
} from '@/modules/dashboard/dashboardActions';
import { sendAnalytics } from '@/services/analyticsService';
import { useDispatch } from 'react-redux';
import { useUserData } from './useUserData';

export const useReminderMutation = () => {
	const dispatch = useDispatch();

	const { user } = useUserData();

	const resetReminderDispatch = () =>
		dispatch(dashboardResetBusinessReminder());

	const deleteReminderDispatch = (
		payload: DashboardDeleteBusinessReminderProps
	) => dispatch(dashboardDeleteBusinessReminder(payload));

	const setReminderDispatch = (payload: DashboardSetBusinessReminderProps) =>
		dispatch(dashboardSetBusinessReminder(payload));

	const onResetReminder = () => {
		resetReminderDispatch();
	};

	const onDeleteReminder = async ({
		businessId,
		businessName,
		userEmail,
		listId
	}: DashboardDeleteBusinessReminderProps) => {
		sendAnalytics({
			type: 'track',
			userId: userEmail,
			eventName: `User deleted a reminder`,
			properties: {
				businessId,
				businessName
			}
		});

		deleteReminderDispatch({
			businessId,
			businessName,
			userEmail,
			listId
		});
	};

	const onSetReminder = async ({
		note,
		triggerDate,
		noteHtml,
		originalNote,
		businessId,
		businessName,
		userEmail,
		listId
	}: DashboardSetBusinessReminderProps) => {
		sendAnalytics({
			type: 'track',
			userId: user.email,
			eventName: `User set a reminder`,
			properties: {
				businessId,
				businessName,
				text: note
			}
		});

		setReminderDispatch({
			note,
			triggerDate,
			noteHtml,
			originalNote,
			businessId,
			businessName,
			userEmail,
			listId
		});
	};

	return { onResetReminder, onDeleteReminder, onSetReminder };
};
